// hooks/useImageProcessing.js - VERSIÓN IDÉNTICA A VerPropiedad
import { useState, useEffect } from 'react';
import { buildAssetUrl } from '../../utils/api';

export const useImageProcessing = (propiedad) => {
  const [imagenesProcesadas, setImagenesProcesadas] = useState([]);

  // MISMA FUNCIÓN QUE VerPropiedad.jsx
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    if (imagePath.startsWith('/uploads')) {
      return buildAssetUrl(imagePath);
    }
    
    if (!imagePath.startsWith('/')) {
      return buildAssetUrl(imagePath);
    }
    
    return buildAssetUrl(imagePath);
  };

  // MISMA LÓGICA DE PARSEO QUE VerPropiedad
  const parseImagenes = (imagenes) => {
    if (!imagenes || !Array.isArray(imagenes)) return [];
    
    return imagenes.map(img => {
      try {
        if (typeof img === 'string' && img.trim().startsWith('{')) {
          return JSON.parse(img);
        }
        return img;
      } catch (error) {
        if (typeof img === 'string') {
          const urlMatch = img.match(/\/uploads\/[^"]+/);
          if (urlMatch) {
            return {
              url: urlMatch[0],
              descripcion: '',
              tags: [],
              orden: 0
            };
          }
        }
        return { url: img, descripcion: '', tags: [], orden: 0 };
      }
    });
  };

  useEffect(() => {
    if (!propiedad) {
      setImagenesProcesadas([]);
      return;
    }

    const imgs = [];
    
    // Foto principal (siempre string)
    if (propiedad.foto_principal) {
      imgs.push({
        url: propiedad.foto_principal,
        descripcion: '',
        tags: [],
        orden: 0
      });
    }
    
    // Imágenes secundarias (parsear igual que VerPropiedad)
    if (propiedad.imagenes && Array.isArray(propiedad.imagenes)) {
      const parsed = parseImagenes(propiedad.imagenes);
      parsed.forEach((img, index) => {
        if (img && (img.url || img)) {
          imgs.push({
            url: img.url || img,
            descripcion: img.descripcion || '',
            tags: img.tags || [],
            orden: img.orden || index + 1
          });
        }
      });
    }
    
    console.log('✅ Imágenes procesadas:', imgs);
    setImagenesProcesadas(imgs);
  }, [propiedad]);

  const getSafeImageUrl = (img) => {
    if (!img) return 'https://via.placeholder.com/800x600?text=Imagen+No+Disponible';
    
    let imageUrl;
    if (typeof img === 'string') {
      try {
        const parsed = JSON.parse(img);
        imageUrl = parsed.url;
      } catch {
        imageUrl = img;
      }
    } else if (img && typeof img === 'object') {
      imageUrl = img.url || img;
    } else {
      imageUrl = img;
    }
    
    const url = getImageUrl(imageUrl);
    return url || 'https://via.placeholder.com/800x600?text=Imagen+No+Disponible';
  };

  return {
    imagenesProcesadas,
    getImageUrl,
    getSafeImageUrl
  };
};
